export enum Events {
    // eslint-disable-next-line no-unused-vars
    reload = 'eventgallery-minicart-reload',
    // eslint-disable-next-line no-unused-vars
    prepareAdd2cartDialogContent = 'eventgallery-prepare-add2cartdialogcontent',
    // eslint-disable-next-line no-unused-vars
    rebindAdd2CartButtons = 'eventgallery-rebind-add2cart-buttons',
    // Fired whenever a request to the cart starts or finishes. The detail
    // carries `{busy: boolean}`. Everything which can take the visitor away
    // from the page listens to this, so that no request is left in flight.
    // eslint-disable-next-line no-unused-vars
    busy = 'eventgallery-minicart-busy',
    // Fired when a request to the cart did not succeed. The detail carries
    // `{error: Error}`.
    // eslint-disable-next-line no-unused-vars
    error = 'eventgallery-minicart-error',
    // Fired by the multi-image dialog once the selected images are in the
    // cart. The detail carries `{count: number}`.
    // eslint-disable-next-line no-unused-vars
    selectionAdded = 'eventgallery-selection-added',
    // Fired when the buy mode of an event page is switched on or off. The
    // detail carries `{active: boolean}`.
    // eslint-disable-next-line no-unused-vars
    buyModeChanged = 'eventgallery-buy-mode-changed'
}
